import { Empty, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import { isLoadFailed } from './useVinRequest';
import VinLoadError from './VinLoadError';
import BatchCarsTable from './BatchCarsTable';

/** First load → skeleton; a failed or unreadable answer → error with Retry; no cars → empty; else the table. */
const BatchCarsBody = ({ cars, columns }) => {
    const { t } = useTranslation('vinExtraction');
    const { load, query, setQuery, fetchCars } = cars;

    if (load.status === 'loading' && !load.data) return <Skeleton active paragraph={{ rows: 4 }} />;
    if (isLoadFailed(load)) {
        return (
            <VinLoadError
                status={load.status}
                error={load.error}
                message={t('cars.loadFailed')}
                invalidDescription={t('cars.invalidResponse')}
                onRetry={fetchCars}
            />
        );
    }
    // E12: a batch whose cars are gone from a1_cars (or that never had any) lists nothing, without a crash
    if (!load.data.items.length) {
        return <Empty description={query.search ? t('cars.emptySearch') : t('cars.empty')} />;
    }

    return (
        <BatchCarsTable
            data={load.data}
            loading={load.status === 'loading'}
            query={query}
            setQuery={setQuery}
            columns={columns}
        />
    );
};

export default BatchCarsBody;
